module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "oss-file"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": _vm.id,
      "accept": "image/png,image/jpeg,image/bmp,image/jpg",
      "multiple": _vm.multiple
    },
    on: {
      "change": _vm.doUpload
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-53d89898"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/aliUpload/aliUpload.vue
// module id = 831
// module chunks = 39